var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueApexCharts',{attrs:{"height":_vm.props.height ? _vm.props.height : '300px',"options":_vm.props.options,"series":_vm.series.length > 0 ? _vm.series : _vm.props.series}})}
var staticRenderFns = []

export { render, staticRenderFns }